export default __webpack_public_path__ + "static/media/empresario.0e77a13f.jpeg";